//@flow

import {
  getInvoiceByProviderApi,
  getProvidersApi,
  getStoreProvidersConfigApi,
  createStoreProvidersConfigApi,
  getInvoiceTypesApi,
  getOrderTaxInvoiceListApi,
  getOrderTaxInvoiceListByIdsApi,
  getStoreTaxInvoiceTypeApi,
  endpoints,
  editOrderTaxInvoiceDataApi,
  cancelOrderTaxInvoiceApi,
  getOrderTaxInvoiceInformationListByIdsApi,
  generateOrderTaxInvoiceApi,
  getTaxInvoiceSettingApi,
  setTaxInvoiceSettingApi,
  getOrderTaxInvoiceInformationApi,
} from './api';
import type {
  OrderTaxInvoice,
  GenerateOrderTaxInvoiceResponse,
  EditOrderTaxInvoiceInformationResponse,
} from './api';

import type {
  TaxInvoiceResponse,
  TaxInvoiceType,
  CreateTaxInvoiceProviderRequest,
  PaginationRequest,
  PaginationResponse,
  TaxInvoiceStoreProvider,
  StoreTaxInvoiceType,
  OrderTaxInvoiceDataRequest,
  TaxInvoiceSettingRequest,
  TaxInvoiceSetting,
} from '../../entities';
import {buildRoute} from '../../http';

export function getProvidersService(
  countryId: string
): Promise<TaxInvoiceResponse[]> {
  return getProvidersApi({
    country: countryId,
  }).toPromise();
}

export function getInvoiceByProviderService(providerId: string) {
  return getInvoiceByProviderApi({
    providerId,
  }).toPromise();
}

export function getStoreProvidersConfigService(
  storeId: string
): Promise<TaxInvoiceStoreProvider[]> {
  return getStoreProvidersConfigApi().toPromise();
}

export function getInvoiceTypesService(
  providerId: string
): Promise<TaxInvoiceType[]> {
  return getInvoiceTypesApi({
    provider_id: providerId,
  }).toPromise();
}

export function createStoreProvidersConfigService(
  storeId: string,
  payload: CreateTaxInvoiceProviderRequest
) {
  return createStoreProvidersConfigApi(payload).toPromise();
}

type ListOrderParams = {
  pagination?: PaginationRequest,
  startDate?: string,
  endDate?: string,
  query?: string,
};

const defaultParams: ListOrderParams = {
  pagination: {
    size: 10,
    page: 0,
  },
};

export function listTaxInvoiceOrdersService(
  params: ListOrderParams = defaultParams
): Promise<PaginationResponse<OrderTaxInvoice>> {
  const queryParams = {
    init_date: params.startDate,
    end_date: params.endDate,
    page: String(params.pagination?.page),
    size: String(params.pagination?.size),
    receiver_name: params.query || undefined,
  };

  // $FlowFixMe
  return getOrderTaxInvoiceListApi(queryParams).toPromise();
}
type TaxInvoiceOrdersByIdsResponse = {
  orderId: string,
  orderTaxInvoices: OrderTaxInvoice[],
};

export async function getTaxInvoiceOrdersByIdsService(
  ids: string[]
): Promise<TaxInvoiceOrdersByIdsResponse[]> {
  const queryParams = {
    order_ids: ids.join(','),
  };

  return getOrderTaxInvoiceListByIdsApi(queryParams).toPromise();
}

export function getOrderTaxInvoiceInformationListByIdsService(
  ids: string[]
): Promise<OrderTaxInvoice[]> {
  const queryParams = {
    order_ids: ids.join(','),
  };

  return getOrderTaxInvoiceInformationListByIdsApi(queryParams).toPromise();
}

export function getStoreTaxInvoiceTypeService(): Promise<
  StoreTaxInvoiceType[]
> {
  return getStoreTaxInvoiceTypeApi().toPromise();
}

export function getOrderTaxInvoiceInformationService(
  orderId: string
): Promise<OrderTaxInvoice> {
  const route = buildRoute(endpoints.GET_ORDER_TAX_INVOICE_INFORMATION, [
    orderId,
  ]);
  return getInvoiceByProviderApi({
    route,
  }).toPromise();
}

export function generateOrderTaxInvoiceService(
  orderId: string
): Promise<GenerateOrderTaxInvoiceResponse> {
  const route = buildRoute(endpoints.GENERATE_ORDER_TAX_INVOICE, [orderId]);
  return generateOrderTaxInvoiceApi(undefined, {
    route,
  }).toPromise();
}

export function editOrderTaxInvoiceDataService(
  orderId: string,
  data: OrderTaxInvoiceDataRequest
): Promise<EditOrderTaxInvoiceInformationResponse> {
  const route = buildRoute(endpoints.EDIT_ORDER_TAX_INVOICE_DATA, [orderId]);
  return editOrderTaxInvoiceDataApi(data, {
    route,
  }).toPromise();
}

export function cancelOrderTaxInvoiceService(orderTaxInvoiceId: string) {
  const route = buildRoute(endpoints.CANCEL_ORDER_TAX_INVOICE, [
    orderTaxInvoiceId,
  ]);
  return cancelOrderTaxInvoiceApi(
    {},
    {
      route,
    }
  ).toPromise();
}

export function getTaxInvoiceSettingService(): Promise<TaxInvoiceSetting> {
  return getTaxInvoiceSettingApi().toPromise();
}

export function setTaxInvoiceSettingService(
  data: TaxInvoiceSettingRequest
): Promise<TaxInvoiceSetting> {
  return setTaxInvoiceSettingApi(data).toPromise();
}

export const EXPORT_TAX_INVOICE_DOCUMENTS_URL =
  endpoints.EXPORT_TAX_INVOICE_DATA;

export function getTaxInvoiceDocumentsService(orderId: string) {
  const route = buildRoute(endpoints.GET_ORDER_TAX_INVOICE_INFORMATION, [
    orderId,
  ]);
  return getOrderTaxInvoiceInformationApi(undefined, {
    route,
  }).toPromise();
}
